import { FormControl, FormGroup } from '@angular/forms';

export function validateAllFormFieldsExplicitly(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      control.updateValueAndValidity();
    } else if (control instanceof FormGroup) {
      validateAllFormFieldsExplicitly(control);
    }
  });
}
